module.exports = __webpack_public_path__ + "img/bg-mini-game.aa88db2c.svg";